<template>

    <div class="container">


        <div id="datePickerWrapper" class="mb-2">
            <div class="row">
              

                <div class="col-4">
                    <datepicker ref="datepicker" :minimumView="'month'" :maximumView="'month'"
                        :open-date="dateToOpen" v-model="currentDate" name="date" :format="customFormatter"
                        :calendar-button="true" calendar-button-icon="fas fa-calendar-alt" :bootstrap-styling="true"
                        class="datepicker-input" @input="changeMonth">
                    </datepicker>
                </div>


                <div class="col-8">
                    
                    
                    <div class="row">

                        <div class="col-12 col-sm-12">
                            <div class="legend-wrapper">

                                <div class="legend-item">
                                    <span class="legend-heading">凡例</span>
                                </div>

                                <div class="legend-item">
                                    <span class="legend-colors-box legend-reserved"></span>
                                    <span class="legend-label">予約済み</span>
                                </div>

                                <div class="legend-item">
                                    <span class="legend-colors-box legend-absent"></span>
                                    <span class="legend-label">欠席</span>
                                </div>

                                <div class="legend-item">
                                    <span class="legend-colors-box legend-cancelled"></span>
                                    <span class="legend-label">講師キャンセル</span>
                                </div>

                                <div class="legend-item">
                                    <span class="legend-colors-box legend-completed"></span>
                                    <span class="legend-label">レッスン完了</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


               
            </div>
        </div>

        <!--
        <button @click="prevMonth">Previous</button>
        <span>{{ monthYear }}</span>
        <button @click="nextMonth">Next</button>
        -->

        <div class="calendar">

            <div class="header" v-for="day in daysOfWeek" :key="day">{{ day }}</div>
            <div v-for="day in daysInMonth" :key="day.date ? day.date.toDateString() : day.index"
                :class="{ 'current-day': day.isToday }" class="day-cell">
                <div v-if="day.date" class="date">{{ day.date.getDate() }}</div>
                <div v-if="loading == false">

                    <ul v-if="day.names && day.names.length">
                        <li v-for="(name, index) in day.names.slice(0, 3)" :key="name + '-' + index"
                            v-b-tooltip.hover.html
                            :title="itemTooltip(name)"
                            class="schedule-item-clickable"
                            role="button"
                            tabindex="0"
                            @click="loginAsMember(name.memberUserId)"
                            @keyup.enter="loginAsMember(name.memberUserId)"
                            :class="{
                            'schedule-reserved': name.status === 'CLIENT_RESERVED' || name.status === 'CLIENT_RESERVED_B',
                            'schedule-absent': name.status === 'CLIENT_NOT_AVAILABLE',
                            'schedule-suppressed': name.status === 'SUPPRESSED_SCHEDULE',
                            'schedule-cancelled': name.status === 'TUTOR_CANCELLED',
                            'schedule-completed': name.status === 'COMPLETED'
                        }">
                            <div class="member-info">
                                <span class="nickname">{{ name.nickname }}</span>
                                <span class="separator"> - </span>
                                <span class="time">{{ name.time }}</span>                               
                            </div>

                        </li>

                     

                        <div v-if="day.names.length > 3" class="text-center mt-2">
                            <button type="button" class="btn btn-cal-schedule btn-primary btn-sm small" @click="openSchedule(day)">
                                <span class="small">すべて表示 ({{ day.names.length }})</span>
                            </button>
                        </div>
                    </ul>
                </div>
            </div>
        </div>


        <b-modal id="modalDaySchedule" class="modalSchedule" :title="ModalScheduleTitle" ok-only ok-title="閉じる" size="lg"
            modal-class="agent-netenglish-modal">
            <div class="schedules">

                <!---
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li v-for="(name, index) in this.modalScheduleList" 
                            :key="name + '-' + index"
                            :class="{
                                'schedule-reserved': name.status === 'CLIENT_RESERVED',
                                'schedule-absent': name.status === 'CLIENT_NOT_AVAILABLE',
                                'schedule-suppressed': name.status === 'SUPPRESSED_SCHEDULE',
                                'schedule-cancelled': name.status === 'TUTOR_CANCELLED',
                                'schedule-completed': name.status === 'COMPLETED'
                                
                            }" class="list-group-item">

                            <div class="name">
                                <span class="pl-1">{{  name.time }}</span>
                                <span class="pl-1">{{  name.nickname }}</span>
                            </div>
                        </li>   
                    </ul>
                </div>
                -->

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Full Name (Nickname)</th>
                            <th scope="col">担当講師</th>
                            <th scope="col">Reservation Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(name, index) in this.modalScheduleList" :key="name + '-' + index"
                            class="schedule-row-clickable"
                            role="button"
                            tabindex="0"
                            @click="loginAsMember(name.memberUserId)"
                            @keyup.enter="loginAsMember(name.memberUserId)">
                            <th scope="row">{{ name.time }}</th>
                            <td>{{ name.firstname }} {{ name.lastname }} {{ "(" + name.nickname + ")" }}</td>
                            <td>{{ name.tutorName }}</td>
                            <td>{{ getStatus(name.status) }}</td>
                        </tr>

                    </tbody>
                </table>

            </div>
        </b-modal>


    </div>

</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
export default {
    computed: {
        monthYear() {
            return this.currentDate.toLocaleString('default', {
                month: 'long',
                year: 'numeric',
            });
        },
        daysInMonth() {


            const year = this.currentDate.getFullYear();
            const month = this.currentDate.getMonth();

            this.currentMonth = month;
            this.currentYear = year;

            const firstDay = new Date(year, month, 1).getDay();
            const lastDate = new Date(year, month + 1, 0).getDate();
            const today = new Date();

            const days = [];
            let index = 0;

            for (let i = 0; i < firstDay; i++) {
                days.push({ date: null, index: index++ });
            }

            for (let date = 1; date <= lastDate; date++) {
                const day = new Date(year, month, date);

                //array to member names and its schedule
                const memberNames = this.memberList[date];

                days.push({
                    date: day,
                    day: date,
                    isToday: day.toDateString() === today.toDateString(),
                    index: index++,
                    names: memberNames, // Add names here
                });
            }

            return days;
        },
    },
    components: {
        Datepicker
    },
    props: {
        agent_info: Object,
        agent_user_id: Number,
        csrf_token: String,
        api_token: String,
        is_netenglish: String
    },
    data() {
        return {

            currentDate: new Date(),
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],

            loading: true,

            //Day Schedule Modal
            modalScheduleList: [],
            memberList: [],
            ModalScheduleTitle: "",

            currentMonth: "",
            currentYear: "",


            dateToOpen: null,
        };
    },
    mounted: function () {

        window.getMemberSchedule = this.getMemberSchedule;
        window.refreshAgentCalendarViewer = this.refreshAgentCalendarViewer.bind(this);

        this.getMemberSchedule();

    },
    methods: {

        refreshAgentCalendarViewer(date) {
            let month = moment(date).format('MM');
            let year = moment(date).format('YYYY');
            let day = moment(date).format('DD');   // Gets the day
            let newDate = `${year}-${month}-${day}`;

            this.currentDate = new Date(newDate);
            this.dateToOpen = this.currentDate

            this.getMemberSchedule(month, year);
        },
        customFormatter(date) {
            return moment(date).format('YYYY年 MM月');
        },
        changeMonth(selectedDate) {
            //set the month
            this.currentDate.setMonth(selectedDate.getMonth());
            //set the date
            this.currentDate = new Date(this.currentDate);
            let month = this.currentDate.getMonth() + 1;
            let year = this.currentDate.getFullYear();
            this.currentMonth = month;
            this.currentYear = year;
            this.getMemberSchedule(month, year)
        },

        openSchedule(day) {

            let year = this.currentDate.toLocaleString('default', { year: 'numeric' });
            let month = this.currentDate.toLocaleString('default', { month: 'long' });

            this.modalScheduleList = this.memberList[day.day];

            this.ModalScheduleTitle = "Schedules for " + month + " " + day.day + ", " + year;
            this.$bvModal.show('modalDaySchedule');

            console.log(this.modalScheduleList);

        },
        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text == null ? '' : String(text);
            return div.innerHTML;
        },
        tutorDisplayName(schedule) {
            if (!schedule) {
                return '—';
            }

            const japanese = (schedule.tutor_japanese_firstname || '').trim();
            const first = (schedule.tutor_firstname || '').trim();

            if (japanese) {
                return japanese;
            }

            if (first) {
                return first;
            }

            return '—';
        },
        itemTooltip(item) {
            const tutor = this.escapeHtml(item.tutorName || '—');
            return '担当講師：' + tutor + '<br>（クリックで代理ログイン）';
        },
        loginAsMember(memberUserId) {
            if (!memberUserId) {
                return;
            }

            localStorage.setItem('agent_user_id', this.$props.agent_user_id);

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/admin/login-user';

            const csrf = document.querySelector('meta[name="csrf-token"]');
            if (csrf) {
                const csrfInput = document.createElement('input');
                csrfInput.type = 'hidden';
                csrfInput.name = '_token';
                csrfInput.value = csrf.getAttribute('content');
                form.appendChild(csrfInput);
            }

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'member_id';
            input.value = memberUserId;
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
        },
        getStatus(status) {
            if (status === 'CLIENT_RESERVED')
                return '予約済み';
            else if (status === 'CLIENT_RESERVED_B')
                return '予約済み';
            else if (status === 'TUTOR_SCHEDULED')
                return 'Open';
            else if (status === 'CLIENT_NOT_AVAILABLE')
                return '欠席';
            else if (status === 'SUPPRESSED_SCHEDULE')
                return 'Suppressed';
            else if (status === 'TUTOR_CANCELLED')
                return '講師キャンセル';
            else if (status === 'COMPLETED')
                return 'レッスン完了';
            else if (status === null || status === undefined || status === '')
                return 'Unknown';
            else
                return status;

        },
        nextMonth() {
            //set the month
            this.currentDate.setMonth(this.currentDate.getMonth() + 1);
            this.currentDate = new Date(this.currentDate);

            let month = this.currentDate.getMonth() + 1;
            let year = this.currentDate.getFullYear();

            this.currentMonth = month;
            this.currentYear = year;


            this.getMemberSchedule(month, year)

        },
        prevMonth() {
            //set the month
            this.currentDate.setMonth(this.currentDate.getMonth() - 1);
            this.currentDate = new Date(this.currentDate);

            let month = this.currentDate.getMonth() + 1;
            let year = this.currentDate.getFullYear();

            this.currentMonth = month;
            this.currentYear = year;


            this.getMemberSchedule(month, year)
        },
        getTime(lessonTime) {
            const timeString = lessonTime.split(" ")[1]; // "11:00:00"
            const [hours, minutes] = timeString.split(":"); // Split into hours and minutes
            return `${hours}:${minutes}`; // Join hours and minutes
        },
        getMemberSchedule(month, year) {
            console.log("refreshed member schedule current M Y ", month, year);
            this.loading = true;
            axios.post("/api/getAgentMemberSchedules?api_token=" + this.api_token,
                {
                    method: "POST",
                    agentUserID: this.agent_user_id,
                    month: month,
                    year: year,
                }).then(response => {

                    this.loading = false;


                    if (response.data.success == true) {

                        this.loading = false;

                        this.memberList = new Array();
                        let schedules = response.data.schedules;

                        schedules.forEach((schedule) => {

                            if (!this.memberList[schedule.day]) {
                                this.memberList[schedule.day] = [];
                            }
                            // Push the firstname to the array for this date


                            this.memberList[schedule.day].push({
                                'scheduleID': schedule.id,
                                'memberUserId': schedule.member_id,
                                'firstname': schedule.firstname,
                                'lastname': schedule.lastname,
                                'nickname': schedule.nickname,
                                'status': schedule.schedule_status,
                                'time': this.getTime(schedule.adjusted_lesson_time),
                                'MAID': schedule.member_multi_account_id,
                                'tutorName': this.tutorDisplayName(schedule),
                            });
                        });
                    } else {
                        console.log("member schedule failed");
                    }
                });
        },
    },
};
</script>

<style scoped>
.calendar {
    --cal-border: #e5e7eb;
    --cal-radius: 8px;
    --cal-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);

    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;

    .header {
        font-weight: 600;
        font-size: 0.72rem;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #6b7280;
        text-align: center;
        padding: 10px 6px;
        background: #f9fafb;
        border: 1px solid var(--cal-border);
        border-radius: var(--cal-radius);
    }

    .date {
        text-align: right;
        font-weight: 600;
        margin: 4px 8px 2px;
        font-size: 0.95rem;
        color: #374151;
    }

    .day-name,
    .day-cell {
        border: 1px solid var(--cal-border);
        border-radius: var(--cal-radius);
        padding: 4px 0 10px;
        min-height: 150px;
        background: #fff;
        box-shadow: var(--cal-shadow);

        .member-info {
            margin: 0;
            width: 100%;
            line-height: 1.35;
            font-size: 0.8125rem;

            .nickname {
                font-weight: 600;
                color: inherit;
            }

            .separator {
                opacity: 0.55;
                font-weight: 400;
            }

            .time {
                font-size: 0.78rem;
                font-weight: 500;
                opacity: 0.92;
            }
        }
    }

    .current-day {
        background: rgba(25, 165, 252, 0.08);
        border-color: rgba(25, 165, 252, 0.45);
        box-shadow: var(--cal-shadow), inset 3px 0 0 #19a5fc;
    }

    .current-day .date {
        color: #0c4a6e;
    }

    .day-cell ul {
        padding: 0 6px;
        margin: 6px 0 0 0;
        list-style-type: none;
    }

    .day-cell ul li {
        margin-bottom: 6px;
        border-radius: 6px;
        padding: 6px 8px;
        border: 1px solid transparent;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
        transition: box-shadow 0.15s ease, transform 0.15s ease;
    }

    .day-cell ul li:last-child {
        margin-bottom: 0;
    }

    .day-cell ul li.schedule-item-clickable {
        cursor: pointer;
    }

    .day-cell ul li.schedule-item-clickable:hover {
        box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);
        filter: brightness(0.97);
    }

    .day-cell ul li.schedule-item-clickable:focus {
        outline: 2px solid #19a5fc;
        outline-offset: 1px;
    }
}

.schedule-row-clickable {
    cursor: pointer;
}

.schedule-row-clickable:hover {
    background-color: rgba(25, 165, 252, 0.08) !important;
}

@media (max-width: 767.98px) {
    .calendar {
        gap: 6px;

        .header {
            font-size: 0.65rem;
            padding: 6px 2px;
        }

        .day-name,
        .day-cell {
            min-height: 108px;
            padding: 2px 0 8px;
        }

        .date {
            font-size: 0.85rem;
            margin: 2px 4px 0;
        }

        .day-cell ul {
            padding: 0 4px;
        }

        .day-cell ul li {
            padding: 5px 6px;
            font-size: 0.75rem;
        }
    }
}

.schedule-reserved {
    background: #fde047;
    color: #713f12;
    border-color: #ca8a04 !important;
}

.schedule-absent {
    background: #fca5a5;
    color: #7f1d1d;
    border-color: #dc2626 !important;
}

.schedule-suppressed {
    background: #7dd3fc;
    color: #0c4a6e;
    border-color: #0284c7 !important;
}

.schedule-cancelled {
    background: #d1d5db;
    color: #1f2937;
    border-color: #6b7280 !important;
}

.schedule-completed {
    background: #fdba74;
    color: #7c2d12;
    border-color: #ea580c !important;
}

.legend-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
    align-items: center;
    padding: 12px 14px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.8125rem;
}

.legend-heading {
    font-weight: 700;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #6b7280;
    margin-right: 4px;
}

.legend-colors-box {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    display: inline-block;
    flex-shrink: 0;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.legend-reserved {
    background: #fde047;
    border-color: #ca8a04;
}

.legend-absent {
    background: #fca5a5;
    border-color: #dc2626;
}

.legend-cancelled {
    background: #d1d5db;
    border-color: #6b7280;
}

.legend-completed {
    background: #fdba74;
    border-color: #ea580c;
}

.legend-label {
    font-weight: 600;
    color: #374151;
}

.calendar .btn-cal-schedule.btn-primary {
    background-color: #19a5fc;
    border-color: #19a5fc;
    font-weight: 600;
}

.calendar .btn-cal-schedule.btn-primary:hover,
.calendar .btn-cal-schedule.btn-primary:focus {
    background-color: #1486d8;
    border-color: #1486d8;
}
</style>